var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculatorBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.14,244.22s-3.46,23-4,34.63,2.92,58.33,2.92,71.63,10,55,10,55l-2.74,2.19-.18,2.91,8,2.55c4,1.28,4.74,1.1,4.74,1.1s-.91-8.57-.91-27.71,3.1-54.13,3.28-69.63,5.83-30.25,5.83-30.25l2.37-2S360,334.26,360,338.09s-8.93,64-9.48,65.43-1.28,2.19-1.28,4.2v5.65l13.49-5.29a17.43,17.43,0,0,0-.54-4.56,9.32,9.32,0,0,1-.55-3.46c0-.55,19.5-51.76,19.5-57.6A88.67,88.67,0,0,0,380,330.07l-2.19-52.13s2.55-5.47,1.46-10.21-7.11-18.77-8.2-19.68S332.26,254.06,321.14,244.22Z",
    style: {
      fill: "#FF822F",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.83,141.05s-7.66-9.48-7.66-11.3,57.6-25.7,58.51-25.7,16.41,10.75,16.59,11.67,1.09,5.83,1.09,6.56-2.73,2.18-2.73,2.18-3.47,3.29-4.38,3.29h-.91a14.8,14.8,0,0,1-3.64,1.09,3.11,3.11,0,0,1-2-1.09s-5.1,1.27-4.74.36,6.2-4.56,6.2-4.56-6.74-4.19-8-6.92a37.58,37.58,0,0,1-2-5.47L277.58,137Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.55,160.55S331.9,157.82,325,154s-10.39-3.1-13.12-3.1-26.8-12.39-26.8-12.39L274.3,149.44s42.83,31.35,43.56,33.72,2.37,52.13,1.64,56-2,5.47-1.27,6.93,10,9.66,26.25,9.48,27.7-4.74,28.79-6.93,1.1-3.1.37-4.74-1.46-3.64-1.46-3.64L378,200.84l5.84,29.89s2.91,1.64,9.11.55,8.93-2.74,8.93-2.74-9.84-45.2-11.85-50.85-3.28-5.11-9.66-7.47-23.15-7.66-23.15-7.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.33,94H106.45a19.35,19.35,0,0,0-14.3,6.3,19.36,19.36,0,0,0-6.12,15l3.66,80V409.83a17.62,17.62,0,0,0,17.62,17.62H277.44a19.49,19.49,0,0,0,18.63-18.63V194.34l3.67-80A19.43,19.43,0,0,0,280.33,94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.14,205.47s-16,68.58,28.65,128.33,122.64,83,185.27,103.45,121.31-3.16,143.32-55.8-22.45-81-32.25-149.75-2-88.56-47.7-140.91-139.55-51.1-203,2.65S66.14,205.47,66.14,205.47Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.14,205.47s-16,68.58,28.65,128.33,122.64,83,185.27,103.45,121.31-3.16,143.32-55.8-22.45-81-32.25-149.75-2-88.56-47.7-140.91-139.55-51.1-203,2.65S66.14,205.47,66.14,205.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-37"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.5,
    cy: 428.5,
    rx: 180.5,
    ry: 18.5,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384,257.87c-.06,0,.65-3.52.72-3.73.82-2.51,3.87-6.89,6.82-6.88a3.49,3.49,0,0,1,3.36,4c-.21,2.08-2.08,3.85-3.76,4.87C389.17,257.3,384,257.87,384,257.87Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.29,234.2c2.78,1,4.16,6.14,4.07,8.78,0,.23-.53,3.78-.58,3.75l0,0c.22.81.45,1.68.69,2.64.41,1.77.87,3.78,1.22,6a63.19,63.19,0,0,1,.78,7.21,45.46,45.46,0,0,1-.27,8.1.44.44,0,0,1,0,.1c.37-.79,1.46-2.95,1.56-3.11,1.45-2.2,5.54-5.62,8.39-4.83a3.5,3.5,0,0,1,2.19,4.72c-.75,1.94-3,3.16-4.91,3.7-2.14.61-6.9-.11-7.28-.17a62.75,62.75,0,0,1-1.76,8.07q-.66,2.33-1.43,4.63c.33-.67.64-1.26.69-1.34,1.45-2.21,5.54-5.62,8.39-4.84a3.5,3.5,0,0,1,2.2,4.72c-.76,1.95-3,3.16-4.92,3.7s-6,0-7.07-.14c-.21.59-.4,1.18-.6,1.77-1,2.82-2,5.64-2.85,8.42-.31,1-.58,2-.86,2.94.3-.59.56-1.09.61-1.16,1.45-2.2,5.54-5.62,8.39-4.83a3.49,3.49,0,0,1,2.19,4.72c-.75,1.94-3,3.16-4.91,3.7s-5.6.06-6.89-.12c-.25,1-.5,2-.7,3-.12.68-.28,1.32-.36,2s-.19,1.36-.28,2c-.14,1.3-.28,2.63-.38,3.89-.08.88-.13,1.72-.19,2.56.3-1,.92-2.89,1-3a13.56,13.56,0,0,1,4.53-5.15,3.8,3.8,0,0,1,.38-.68,3.5,3.5,0,0,1,5.14-.8c2.24,1.93,1.68,7.23.65,9.66-.06.15-.89,1.63-1.43,2.55.4-.49.78-1,1.2-1.48.82-1,1.67-2,2.58-3.05l1.38-1.5c.45-.51,1-1,1.49-1.49,1.19-1.14,2.44-2.25,3.73-3.33-.88-.72-4-3.32-4.85-5.09s-1.52-4.25-.6-6.12a3.5,3.5,0,0,1,5-1.58c2.5,1.57,2.75,6.9,2.1,9.46,0,.15-.71,1.94-1.1,2.91.78-.64,1.55-1.29,2.36-1.92,2.34-1.8,4.76-3.56,7.17-5.32.74-.54,1.46-1.08,2.19-1.63-.31-.25-4-3.27-5-5.25-.88-1.76-1.51-4.25-.59-6.12a3.49,3.49,0,0,1,5-1.57c2.5,1.57,2.76,6.89,2.11,9.45-.05.19-1,2.75-1.3,3.39,1.61-1.19,3.2-2.4,4.72-3.66a59.81,59.81,0,0,0,5.85-5.44c-.15-.12-4.06-3.25-5.07-5.28-.89-1.76-1.52-4.25-.6-6.12a3.49,3.49,0,0,1,5-1.58c2.51,1.57,2.76,6.9,2.11,9.46,0,.16-.78,2.12-1.15,3l.14.09a45.75,45.75,0,0,0,4.8-6.44c.79-1.25,1.47-2.49,2.11-3.71-.79-.51-4.36-2.87-5.48-4.6s-2-4.06-1.26-6a3.5,3.5,0,0,1,4.76-2.11c2.66,1.29,3.49,6.55,3.13,9.17,0,.14-.38,1.56-.66,2.59.28-.55.58-1.12.83-1.65,1-2,1.74-3.92,2.41-5.61.37-1,.68-1.84,1-2.67-.51-.9-2.53-4.56-2.73-6.57s.12-4.52,1.66-5.93a3.5,3.5,0,0,1,5.19.32c1.77,2.37.08,7.43-1.44,9.58-.13.19-2.53,2.86-2.56,2.81l0,0c-.26.8-.55,1.65-.88,2.58-.63,1.71-1.36,3.63-2.29,5.67a62,62,0,0,1-3.32,6.44,45.37,45.37,0,0,1-4.7,6.61.23.23,0,0,1-.07.07c.74-.45,2.84-1.65,3-1.73,2.42-1,7.72-1.62,9.66.6a3.5,3.5,0,0,1-.77,5.15c-1.71,1.2-4.27,1-6.14.37-2.12-.67-5.7-3.9-6-4.16a62.27,62.27,0,0,1-5.92,5.77c-1.22,1-2.48,2.06-3.75,3.07.65-.37,1.23-.7,1.32-.74,2.42-1,7.72-1.63,9.66.6a3.49,3.49,0,0,1-.77,5.14c-1.7,1.21-4.26,1-6.14.38s-5-3.3-5.83-4l-1.47,1.14c-2.37,1.82-4.75,3.62-7,5.46-.8.65-1.57,1.31-2.34,2l1.15-.64c2.42-1,7.72-1.63,9.66.6a3.51,3.51,0,0,1-.77,5.15c-1.7,1.2-4.26,1-6.14.37s-4.71-3-5.68-3.89c-.77.7-1.54,1.41-2.25,2.13-.47.5-1,.95-1.41,1.47l-1.35,1.53c-.83,1-1.68,2-2.46,3-.55.69-1.06,1.36-1.57,2,.79-.65,2.36-1.9,2.51-2,2.23-1.4,7.38-2.78,9.64-.87a3.49,3.49,0,0,1,0,5.2c-1.5,1.45-4.06,1.6-6,1.3-2.14-.34-6-2.86-6.51-3.18-.84,1.11-1.66,2.2-2.41,3.25-2.61,3.61-4.65,6.71-6,8.9-.05.08-.1.15-.14.23l-1.81-.88.28-.43c1.46-2.19,3.59-5.28,6.3-8.86.86-1.14,1.8-2.34,2.77-3.56a37.52,37.52,0,0,1-2.81-3.47c-2.07.81-6.39.85-6.95.85-.09,1.39-.17,2.75-.22,4-.19,4.45-.17,8.17-.13,10.76,0,.11,0,.2,0,.3l-2-1c0-2.58.1-6.07.36-10.19.09-1.42.21-2.94.35-4.49-.55-.14-5.05-1.29-6.75-2.65-1.54-1.23-3.16-3.22-3.1-5.31a3.5,3.5,0,0,1,3.85-3.51c2.93.38,5.39,5.11,5.87,7.7,0,.16.15,1.85.21,2.92.06-.63.11-1.25.18-1.9.13-1.29.3-2.58.47-4l.33-2c.1-.67.28-1.37.42-2.07.36-1.6.8-3.21,1.27-4.82-1.13-.12-5.14-.59-6.85-1.58s-3.61-2.71-3.87-4.78a3.5,3.5,0,0,1,3.27-4.05c2.95-.07,6.1,4.23,7,6.73.05.15.47,2,.69,3,.29-1,.58-1.93.91-2.9.95-2.79,2-5.59,3-8.39.32-.86.62-1.71.93-2.57-.4,0-5.18-.49-7.1-1.6-1.71-1-3.61-2.71-3.87-4.78a3.49,3.49,0,0,1,3.27-4.05c2.95-.07,6.1,4.23,7,6.72.06.19.67,2.87.79,3.55.68-1.88,1.34-3.77,1.92-5.66a62.47,62.47,0,0,0,1.88-7.76c-.19,0-5.18-.48-7.15-1.61-1.71-1-3.61-2.71-3.87-4.78a3.5,3.5,0,0,1,3.27-4.05c2.95-.07,6.1,4.23,7,6.73.06.16.52,2.2.72,3.17h.17a45.13,45.13,0,0,0,.44-8c0-1.48-.14-2.89-.28-4.26-.94,0-5.22,0-7.11-.81s-3.89-2.3-4.37-4.33a3.49,3.49,0,0,1,2.8-4.38c2.93-.39,6.53,3.54,7.67,5.92.06.13.55,1.51.88,2.53-.07-.62-.13-1.26-.21-1.85-.3-2.21-.71-4.22-1.09-6-.22-1-.45-1.92-.66-2.76-.93-.47-4.63-2.41-5.9-4s-2.4-3.83-1.89-5.86A3.49,3.49,0,0,1,378.29,234.2Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.71,279.75c-2.32-.1-6.93-2.47-6.93-2.47s2.48-2.56,2.66-2.71c2.06-1.64,7-3.61,9.48-2a3.5,3.5,0,0,1,.61,5.17C436.21,279.38,433.68,279.83,431.71,279.75Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384,257.87c-.06,0,.65-3.52.72-3.73.82-2.51,3.87-6.89,6.82-6.88a3.49,3.49,0,0,1,3.36,4c-.21,2.08-2.08,3.85-3.76,4.87C389.17,257.3,384,257.87,384,257.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.29,234.2c2.78,1,4.16,6.14,4.07,8.78,0,.23-.53,3.78-.58,3.75l0,0c.22.81.45,1.68.69,2.64.41,1.77.87,3.78,1.22,6a63.19,63.19,0,0,1,.78,7.21,45.46,45.46,0,0,1-.27,8.1.44.44,0,0,1,0,.1c.37-.79,1.46-2.95,1.56-3.11,1.45-2.2,5.54-5.62,8.39-4.83a3.5,3.5,0,0,1,2.19,4.72c-.75,1.94-3,3.16-4.91,3.7-2.14.61-6.9-.11-7.28-.17a62.75,62.75,0,0,1-1.76,8.07q-.66,2.33-1.43,4.63c.33-.67.64-1.26.69-1.34,1.45-2.21,5.54-5.62,8.39-4.84a3.5,3.5,0,0,1,2.2,4.72c-.76,1.95-3,3.16-4.92,3.7s-6,0-7.07-.14c-.21.59-.4,1.18-.6,1.77-1,2.82-2,5.64-2.85,8.42-.31,1-.58,2-.86,2.94.3-.59.56-1.09.61-1.16,1.45-2.2,5.54-5.62,8.39-4.83a3.49,3.49,0,0,1,2.19,4.72c-.75,1.94-3,3.16-4.91,3.7s-5.6.06-6.89-.12c-.25,1-.5,2-.7,3-.12.68-.28,1.32-.36,2s-.19,1.36-.28,2c-.14,1.3-.28,2.63-.38,3.89-.08.88-.13,1.72-.19,2.56.3-1,.92-2.89,1-3a13.56,13.56,0,0,1,4.53-5.15,3.8,3.8,0,0,1,.38-.68,3.5,3.5,0,0,1,5.14-.8c2.24,1.93,1.68,7.23.65,9.66-.06.15-.89,1.63-1.43,2.55.4-.49.78-1,1.2-1.48.82-1,1.67-2,2.58-3.05l1.38-1.5c.45-.51,1-1,1.49-1.49,1.19-1.14,2.44-2.25,3.73-3.33-.88-.72-4-3.32-4.85-5.09s-1.52-4.25-.6-6.12a3.5,3.5,0,0,1,5-1.58c2.5,1.57,2.75,6.9,2.1,9.46,0,.15-.71,1.94-1.1,2.91.78-.64,1.55-1.29,2.36-1.92,2.34-1.8,4.76-3.56,7.17-5.32.74-.54,1.46-1.08,2.19-1.63-.31-.25-4-3.27-5-5.25-.88-1.76-1.51-4.25-.59-6.12a3.49,3.49,0,0,1,5-1.57c2.5,1.57,2.76,6.89,2.11,9.45-.05.19-1,2.75-1.3,3.39,1.61-1.19,3.2-2.4,4.72-3.66a59.81,59.81,0,0,0,5.85-5.44c-.15-.12-4.06-3.25-5.07-5.28-.89-1.76-1.52-4.25-.6-6.12a3.49,3.49,0,0,1,5-1.58c2.51,1.57,2.76,6.9,2.11,9.46,0,.16-.78,2.12-1.15,3l.14.09a45.75,45.75,0,0,0,4.8-6.44c.79-1.25,1.47-2.49,2.11-3.71-.79-.51-4.36-2.87-5.48-4.6s-2-4.06-1.26-6a3.5,3.5,0,0,1,4.76-2.11c2.66,1.29,3.49,6.55,3.13,9.17,0,.14-.38,1.56-.66,2.59.28-.55.58-1.12.83-1.65,1-2,1.74-3.92,2.41-5.61.37-1,.68-1.84,1-2.67-.51-.9-2.53-4.56-2.73-6.57s.12-4.52,1.66-5.93a3.5,3.5,0,0,1,5.19.32c1.77,2.37.08,7.43-1.44,9.58-.13.19-2.53,2.86-2.56,2.81l0,0c-.26.8-.55,1.65-.88,2.58-.63,1.71-1.36,3.63-2.29,5.67a62,62,0,0,1-3.32,6.44,45.37,45.37,0,0,1-4.7,6.61.23.23,0,0,1-.07.07c.74-.45,2.84-1.65,3-1.73,2.42-1,7.72-1.62,9.66.6a3.5,3.5,0,0,1-.77,5.15c-1.71,1.2-4.27,1-6.14.37-2.12-.67-5.7-3.9-6-4.16a62.27,62.27,0,0,1-5.92,5.77c-1.22,1-2.48,2.06-3.75,3.07.65-.37,1.23-.7,1.32-.74,2.42-1,7.72-1.63,9.66.6a3.49,3.49,0,0,1-.77,5.14c-1.7,1.21-4.26,1-6.14.38s-5-3.3-5.83-4l-1.47,1.14c-2.37,1.82-4.75,3.62-7,5.46-.8.65-1.57,1.31-2.34,2l1.15-.64c2.42-1,7.72-1.63,9.66.6a3.51,3.51,0,0,1-.77,5.15c-1.7,1.2-4.26,1-6.14.37s-4.71-3-5.68-3.89c-.77.7-1.54,1.41-2.25,2.13-.47.5-1,.95-1.41,1.47l-1.35,1.53c-.83,1-1.68,2-2.46,3-.55.69-1.06,1.36-1.57,2,.79-.65,2.36-1.9,2.51-2,2.23-1.4,7.38-2.78,9.64-.87a3.49,3.49,0,0,1,0,5.2c-1.5,1.45-4.06,1.6-6,1.3-2.14-.34-6-2.86-6.51-3.18-.84,1.11-1.66,2.2-2.41,3.25-2.61,3.61-4.65,6.71-6,8.9-.05.08-.1.15-.14.23l-1.81-.88.28-.43c1.46-2.19,3.59-5.28,6.3-8.86.86-1.14,1.8-2.34,2.77-3.56a37.52,37.52,0,0,1-2.81-3.47c-2.07.81-6.39.85-6.95.85-.09,1.39-.17,2.75-.22,4-.19,4.45-.17,8.17-.13,10.76,0,.11,0,.2,0,.3l-2-1c0-2.58.1-6.07.36-10.19.09-1.42.21-2.94.35-4.49-.55-.14-5.05-1.29-6.75-2.65-1.54-1.23-3.16-3.22-3.1-5.31a3.5,3.5,0,0,1,3.85-3.51c2.93.38,5.39,5.11,5.87,7.7,0,.16.15,1.85.21,2.92.06-.63.11-1.25.18-1.9.13-1.29.3-2.58.47-4l.33-2c.1-.67.28-1.37.42-2.07.36-1.6.8-3.21,1.27-4.82-1.13-.12-5.14-.59-6.85-1.58s-3.61-2.71-3.87-4.78a3.5,3.5,0,0,1,3.27-4.05c2.95-.07,6.1,4.23,7,6.73.05.15.47,2,.69,3,.29-1,.58-1.93.91-2.9.95-2.79,2-5.59,3-8.39.32-.86.62-1.71.93-2.57-.4,0-5.18-.49-7.1-1.6-1.71-1-3.61-2.71-3.87-4.78a3.49,3.49,0,0,1,3.27-4.05c2.95-.07,6.1,4.23,7,6.72.06.19.67,2.87.79,3.55.68-1.88,1.34-3.77,1.92-5.66a62.47,62.47,0,0,0,1.88-7.76c-.19,0-5.18-.48-7.15-1.61-1.71-1-3.61-2.71-3.87-4.78a3.5,3.5,0,0,1,3.27-4.05c2.95-.07,6.1,4.23,7,6.73.06.16.52,2.2.72,3.17h.17a45.13,45.13,0,0,0,.44-8c0-1.48-.14-2.89-.28-4.26-.94,0-5.22,0-7.11-.81s-3.89-2.3-4.37-4.33a3.49,3.49,0,0,1,2.8-4.38c2.93-.39,6.53,3.54,7.67,5.92.06.13.55,1.51.88,2.53-.07-.62-.13-1.26-.21-1.85-.3-2.21-.71-4.22-1.09-6-.22-1-.45-1.92-.66-2.76-.93-.47-4.63-2.41-5.9-4s-2.4-3.83-1.89-5.86A3.49,3.49,0,0,1,378.29,234.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.71,279.75c-2.32-.1-6.93-2.47-6.93-2.47s2.48-2.56,2.66-2.71c2.06-1.64,7-3.61,9.48-2a3.5,3.5,0,0,1,.61,5.17C436.21,279.38,433.68,279.83,431.71,279.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M404.74,337.57s-14-33.78-21.85-32.31,13.45,53.85,13.45,53.85-24.66-46.51-41.47-46.51S361,364,382.33,381.14c0,0-33.62-36.23-53.24-28.39s39.23,44.54,39.23,44.54-34.18-10.77-30.26-2.44,14.57,9.79,14.57,9.79l-38.67,2H448.45l-30.26-2.94s31.38-15.67,23-22-26.9,7.34-26.9,7.34,31.94-35.24,25.78-48.46-33.63,24-33.63,24,22.42-47.48,17.94-55.8S404.74,337.57,404.74,337.57Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.74,337.57s-14-33.78-21.85-32.31,13.45,53.85,13.45,53.85-24.66-46.51-41.47-46.51S361,364,382.33,381.14c0,0-33.62-36.23-53.24-28.39s39.23,44.54,39.23,44.54-34.18-10.77-30.26-2.44,14.57,9.79,14.57,9.79l-38.67,2H448.45l-30.26-2.94s31.38-15.67,23-22-26.9,7.34-26.9,7.34,31.94-35.24,25.78-48.46-33.63,24-33.63,24,22.42-47.48,17.94-55.8S404.74,337.57,404.74,337.57Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.23,339.35c-12.33,36.42-12.33,62.2-12.33,62.2s14.57.56,29.7-10.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.06,359A218.31,218.31,0,0,0,393,327",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.64,337.67,398,384.18s21.29-17.93,28.58-28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.46,395.39S364.4,379.7,351,370.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.12,233.83l-7.29,20-4.92.73,3.46,13.49s5.29-6.57,6.93-8.94S401,231.09,401,231.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.89,409.72s-12.21,10.94-13.31,14.77,8.93,1.45,13.86-1.83a64.34,64.34,0,0,0,7.29-5.47l.54,1.46s2.92-.36,3.47-2.18-1.1-6.2-1.1-6.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.06,406.62s12.43,13.31,13.52,17.14-8.93,1.45-13.85-1.83a65.25,65.25,0,0,1-7.29-5.46l-.55,1.45s-2.92-.36-3.46-2.18,1.09-6.2,1.09-6.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.14,244.22s-3.46,23-4,34.63,2.92,58.33,2.92,71.63,10,55,10,55l-2.74,2.19-.18,2.91,8,2.55c4,1.28,4.74,1.1,4.74,1.1s-.91-8.57-.91-27.71,3.1-54.13,3.28-69.63,5.83-30.25,5.83-30.25l2.37-2S360,334.26,360,338.09s-8.93,64-9.48,65.43-1.28,2.19-1.28,4.2v5.65l13.49-5.29a17.43,17.43,0,0,0-.54-4.56,9.32,9.32,0,0,1-.55-3.46c0-.55,19.5-51.76,19.5-57.6A88.67,88.67,0,0,0,380,330.07l-2.19-52.13s2.55-5.47,1.46-10.21-7.11-18.77-8.2-19.68S332.26,254.06,321.14,244.22Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.76,336.4c0-5.5,3.47-62.38,3.47-62.38l-18.74,10.66c1.31,6.88,9.48,49.89,9.48,53.41,0,3.83-8.93,64-9.48,65.43s-1.28,2.19-1.28,4.2v5.65l13.49-5.29a17.43,17.43,0,0,0-.54-4.56,9.32,9.32,0,0,1-.55-3.46c0-.44,12.62-33.66,17.55-49.68C363.8,353.73,365.76,341.78,365.76,336.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342.33,354.67l-1.54-7.76c.07-1.17.15-2.33.22-3.48l-.67,1.22-16.67-84,26.82-4.42c-10.51.25-29.35-12-29.35-12L317,273.33,318.33,330l1.75,21.86c.06,1.26.17,2.71.35,4.29l.57,7.18a6.2,6.2,0,0,0,.74,2.08c2.85,17.28,8.34,40.12,8.34,40.12l-2.74,2.19-.18,2.91,8,2.55c4,1.28,4.74,1.1,4.74,1.1s-.91-8.57-.91-27.71c0-7.18.43-16.61,1-26.39A40.58,40.58,0,0,0,342.33,354.67Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M321.14,244.22s-3.46,23-4,34.63,2.92,58.33,2.92,71.63,10,55,10,55l-2.74,2.19-.18,2.91,8,2.55c4,1.28,4.74,1.1,4.74,1.1s-.91-8.57-.91-27.71,3.1-54.13,3.28-69.63,5.83-30.25,5.83-30.25l2.37-2S360,334.26,360,338.09s-8.93,64-9.48,65.43-1.28,2.19-1.28,4.2v5.65l13.49-5.29a17.43,17.43,0,0,0-.54-4.56,9.32,9.32,0,0,1-.55-3.46c0-.55,19.5-51.76,19.5-57.6A88.67,88.67,0,0,0,380,330.07l-2.19-52.13s2.55-5.47,1.46-10.21-7.11-18.77-8.2-19.68S332.26,254.06,321.14,244.22Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350.49,
    y1: 284.68,
    x2: 368.35,
    y2: 273.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.78,
    y1: 283.41,
    x2: 365.07,
    y2: 279.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.94,
    y1: 255.7,
    x2: 348.12,
    y2: 274.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "350.49 256.25 351.4 272.11 349.4 274.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.89,
    y1: 254.79,
    x2: 364.34,
    y2: 268.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.07,
    y1: 253.33,
    x2: 368.54,
    y2: 260.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.99,
    y1: 254.79,
    x2: 326.61,
    y2: 276.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.54,
    y1: 256.07,
    x2: 333.54,
    y2: 272.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.83,141.05s-7.66-9.48-7.66-11.3,57.6-25.7,58.51-25.7,16.41,10.75,16.59,11.67,1.09,5.83,1.09,6.56-2.73,2.18-2.73,2.18-3.47,3.29-4.38,3.29h-.91a14.8,14.8,0,0,1-3.64,1.09,3.11,3.11,0,0,1-2-1.09s-5.1,1.27-4.74.36,6.2-4.56,6.2-4.56-6.74-4.19-8-6.92a37.58,37.58,0,0,1-2-5.47L277.58,137Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.31,106.12c-14.46,5.83-53.14,22.14-53.14,23.63,0,1.82,7.66,11.3,7.66,11.3l10.75-4,35.49-25.84Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.83,141.05s-7.66-9.48-7.66-11.3,57.6-25.7,58.51-25.7,16.41,10.75,16.59,11.67,1.09,5.83,1.09,6.56-2.73,2.18-2.73,2.18-3.47,3.29-4.38,3.29h-.91a14.8,14.8,0,0,1-3.64,1.09,3.11,3.11,0,0,1-2-1.09s-5.1,1.27-4.74.36,6.2-4.56,6.2-4.56-6.74-4.19-8-6.92a37.58,37.58,0,0,1-2-5.47L277.58,137Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.69,127.75s3.85-.81,4.22-1.63,1.12-3.22.53-4.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.34,127.75s2-1.11,2.24-2.83a30.34,30.34,0,0,0-.52-5.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.63,124.46a5.84,5.84,0,0,0,.24-3.66c-.52-2-.9-4.11-.9-4.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.55,160.55S331.9,157.82,325,154s-10.39-3.1-13.12-3.1-26.8-12.39-26.8-12.39L274.3,149.44s42.83,31.35,43.56,33.72,2.37,52.13,1.64,56-2,5.47-1.27,6.93,10,9.66,26.25,9.48,27.7-4.74,28.79-6.93,1.1-3.1.37-4.74-1.46-3.64-1.46-3.64L378,200.84l5.84,29.89s2.91,1.64,9.11.55,8.93-2.74,8.93-2.74-9.84-45.2-11.85-50.85-3.28-5.11-9.66-7.47-23.15-7.66-23.15-7.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.2,252.59c-6.62,0-18.62-.83-23.17-4.14s-10.76-27.31-10.76-27.31l12,16.55-20.5-86a20.93,20.93,0,0,0-7.92-.81c-2.74,0-26.8-12.39-26.8-12.39L274.3,149.44s42.83,31.35,43.56,33.72,2.37,52.13,1.64,56-2,5.47-1.27,6.93,10,9.66,26.25,9.48a77.17,77.17,0,0,0,20.92-3C364.38,252.58,363.31,252.59,362.2,252.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.25 202.58 381.45 192.64 382.16 197.61 388.9 193.35 383.85 230.73 378.25 202.58",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.55,160.55S331.9,157.82,325,154s-10.39-3.1-13.12-3.1-26.8-12.39-26.8-12.39L274.3,149.44s42.83,31.35,43.56,33.72,2.37,52.13,1.64,56-2,5.47-1.27,6.93,10,9.66,26.25,9.48,27.7-4.74,28.79-6.93,1.1-3.1.37-4.74-1.46-3.64-1.46-3.64L378,200.84l5.84,29.89s2.91,1.64,9.11.55,8.93-2.74,8.93-2.74-9.84-45.2-11.85-50.85-3.28-5.11-9.66-7.47-23.15-7.66-23.15-7.66Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "383.82 189.39 378.01 200.84 389.19 189.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.86,
    y1: 183.16,
    x2: 312.21,
    y2: 160.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.86,
    y1: 182.43,
    x2: 306.2,
    y2: 153.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.56,181.92s9.88,43.49,17,52.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.75,202.9s5.32,34.22,10.19,41.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.73,171.31l6.92,17.13-3.82,51.95,7.47,18.05L354.14,238l-8.21-50.12,12.58-16-1.28-.92s-3.82,2.92-7.47,6.38-6.92,3.83-8.75,1.28-3.46-9.66-3.46-9.66Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.48,152.17s-6.2.73-8,4-4.93,4.19-5.47,10.39-1.28,9.48-.55,9.48,8.57-5.47,8.57-5.47,2.73,7.84,3.83,8.38,2.91-.54,4.55-1.82,5.47-5.83,7.29-4.92,5.65,10.39,7.11,8,6-13.85,2.37-22.24S344.48,152.17,344.48,152.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.83,150.89s1.09,17.87,1.28,23.15,1.64,6.56,2.91,5.47,12.4-11.3,13.49-17.31,1.64-9.48,1.64-9.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.46,134.13s-1.82-5.84-4-4.93-2.92,7.48-1.46,10.39,5.47,3.1,6,1.83S338.46,134.13,338.46,134.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.45,131.21l9.29-7.66,3.47-.73-1.83,3.29-10.2,7.65S368.9,133.58,369.45,131.21Z",
    style: {
      fill: "#FF822F",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.74 123.55 378.36 123.87 380.21 126.23 380.38 126.11 382.21 122.82 378.74 123.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.45,132.85s3.64-3.65,4.92-.73.18,6.56-2.55,9.11-4.38,2-4.38.19S369.45,132.85,369.45,132.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.29,108.43s-6.92,1.27-7.47,4.92,1.28,31.35,2.19,35.72,8.75,13.13,14.94,12.76,10.76-7.65,12.4-11.85,6.56-28.8,6.56-34.45-10.21-12.21-18-12.21S344.29,108.43,344.29,108.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.12,134.76s2.92,6.93,1.82,8.39-7.11,2.18-7.11-1.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.83,146.25s3.83,4.55,11.48.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.12,133.85a6.38,6.38,0,1,0-6.38,6.38A6.38,6.38,0,0,0,352.12,133.85Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.52,135a6.38,6.38,0,1,0-6.38,6.37A6.38,6.38,0,0,0,368.52,135Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.12,133.85s2.18-.73,3.64.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.87,103.32c-7.84,0-10.58,5.11-10.58,5.11s-6.92,1.27-7.47,4.92c-.28,1.87.06,10.1.59,18.25.2.14,1.23.76,1.23-.39s-.73-3.1.19-4.19,3.64-1.64,5.46-4.56,1.28-4.74,1.83-5.29,6.38-4.37,5.1-1.64-9.48,7.48-4.74,10,14.76,2.37,18.23-.18,6-8.21,5.47-5.65-2.19,6.74-1.64,8a28,28,0,0,1,.91,5.1s-1.64,5.83-1.1,6.2a1.11,1.11,0,0,0,.72,0c1.87-8.78,3.84-20,3.84-23.53C372.91,109.88,362.7,103.32,354.87,103.32Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.75,227.81l.36,6.2s1.28,1.82,9.85,1.46,13.3-3.28,13.3-3.28l-1.82-8.2S390.59,228.36,380.75,227.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.78,133.4l-21.51,8.2s9.3,10.93,9.84,10.75,16-12.21,15.86-13.49S283.78,133.4,283.78,133.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.33,94H106.45a19.35,19.35,0,0,0-14.3,6.3,19.36,19.36,0,0,0-6.12,15l3.66,80V409.83a17.62,17.62,0,0,0,17.62,17.62H277.44a19.49,19.49,0,0,0,18.63-18.63V194.34l3.67-80A19.43,19.43,0,0,0,280.33,94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.92,96.53A19.39,19.39,0,0,1,293.74,109l-3.67,80V403.49a19.49,19.49,0,0,1-18.63,18.63H101.31A17.62,17.62,0,0,1,92.94,420a17.57,17.57,0,0,0,14.37,7.44H277.44a19.49,19.49,0,0,0,18.63-18.63V194.34l3.67-80A19.45,19.45,0,0,0,289.92,96.53Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,94H106.45a19.35,19.35,0,0,0-14.3,6.3,19.36,19.36,0,0,0-6.12,15l3.66,80V409.83a17.62,17.62,0,0,0,17.62,17.62H277.44a19.49,19.49,0,0,0,18.63-18.63V194.34l3.67-80A19.43,19.43,0,0,0,280.33,94Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.63,191.9,290,117.24a11.91,11.91,0,0,0-11.9-12.45H108.69a11.91,11.91,0,0,0-11.9,12.45l3.36,74.66Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.79,
    y: 124.17,
    width: 172.41,
    height: 58.31,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.3,
    y: 132.68,
    width: 155.39,
    height: 41.29,
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.11,
    y: 215.58,
    width: 86.99,
    height: 25.53,
    rx: 4.97,
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.39,
    y1: 215.9,
    x2: 125.39,
    y2: 241.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.94,
    y1: 215.9,
    x2: 142.94,
    y2: 241.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.48,
    y1: 215.9,
    x2: 160.48,
    y2: 241.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.02,
    y1: 215.9,
    x2: 178.02,
    y2: 241.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.22,
    y: 229.61,
    width: 30.95,
    height: 20.04,
    rx: 4.62,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 257.27,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.91,
    y: 257.27,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.81,257.27h21.7a4.63,4.63,0,0,1,4.63,4.63v14.34a4.63,4.63,0,0,1-4.62,4.63h-21.7a4.62,4.62,0,0,1-4.62-4.62V261.89A4.62,4.62,0,0,1,184.81,257.27Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.47,
    y: 257.27,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.75,
    y: 257.27,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 288.98,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.91,
    y: 288.98,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.81,289h21.7a4.63,4.63,0,0,1,4.63,4.63v14.34a4.63,4.63,0,0,1-4.62,4.63h-21.7a4.62,4.62,0,0,1-4.62-4.62V293.6A4.62,4.62,0,0,1,184.81,289Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.47,
    y: 288.98,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.75,
    y: 288.98,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 320.69,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.91,
    y: 320.69,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.81,320.69h21.7a4.63,4.63,0,0,1,4.63,4.63v14.34a4.63,4.63,0,0,1-4.62,4.63h-21.7a4.62,4.62,0,0,1-4.62-4.62V325.32A4.62,4.62,0,0,1,184.81,320.69Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.47,
    y: 320.69,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.75,
    y: 320.69,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 352.4,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#FF822F",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.91,
    y: 352.4,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.81,352.4h21.7a4.63,4.63,0,0,1,4.63,4.63v14.34a4.63,4.63,0,0,1-4.62,4.63h-21.7a4.62,4.62,0,0,1-4.62-4.62V357A4.62,4.62,0,0,1,184.81,352.4Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.47,
    y: 352.4,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 384.12,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#FF822F",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.91,
    y: 384.12,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.81,384.12h21.7a4.63,4.63,0,0,1,4.63,4.63v14.34a4.63,4.63,0,0,1-4.62,4.63h-21.7a4.62,4.62,0,0,1-4.62-4.62V388.74A4.62,4.62,0,0,1,184.81,384.12Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.47,
    y: 384.12,
    width: 30.95,
    height: 23.59,
    rx: 4.62,
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,352.4H257.44a4.7,4.7,0,0,0-4.69,4.7V403a4.69,4.69,0,0,0,4.69,4.69H279A4.69,4.69,0,0,0,283.7,403V357.1A4.7,4.7,0,0,0,279,352.4Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.75,
    y: 229.61,
    width: 30.95,
    height: 20.04,
    rx: 4.62,
    style: {
      fill: "#FF822F",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.72,244.59a7,7,0,0,1,0-8.43,5.63,5.63,0,0,1,7.78,0,7,7,0,0,1,0,8.43,5.63,5.63,0,0,1-7.78,0Zm6.56-.92a6.15,6.15,0,0,0,0-6.6,3.2,3.2,0,0,0-2.67-1.2,3.23,3.23,0,0,0-2.68,1.2,6.21,6.21,0,0,0,0,6.6,3.21,3.21,0,0,0,2.68,1.21A3.18,3.18,0,0,0,265.28,243.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.47,245.79a.64.64,0,0,1-.22-.51v-9.51a1,1,0,0,1,.26-.74.84.84,0,0,1,.64-.27,1.18,1.18,0,0,1,.57.16,1.45,1.45,0,0,1,.5.46l5.72,8.32v-8.24a.64.64,0,0,1,.21-.51.73.73,0,0,1,.52-.19.71.71,0,0,1,.5.19.61.61,0,0,1,.22.51V245a1,1,0,0,1-.27.74,1,1,0,0,1-.69.28,1.13,1.13,0,0,1-.53-.14,1.16,1.16,0,0,1-.44-.38l-5.74-8.32v8.14a.61.61,0,0,1-.22.51.81.81,0,0,1-.52.19A.76.76,0,0,1,270.47,245.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,275.5a1.24,1.24,0,0,1-.41-.51l-3.65-8.21v8.54a.47.47,0,0,1-.22.42.94.94,0,0,1-1,0,.47.47,0,0,1-.22-.42V266a1,1,0,0,1,.36-.76,1.23,1.23,0,0,1,.83-.3,1.27,1.27,0,0,1,.74.23,1.54,1.54,0,0,1,.56.7l3.57,7.91,3.56-7.91a1.47,1.47,0,0,1,.55-.7,1.32,1.32,0,0,1,1.58.07,1,1,0,0,1,.36.76v9.29a.47.47,0,0,1-.22.42.85.85,0,0,1-.51.15.88.88,0,0,1-.51-.15.5.5,0,0,1-.22-.42v-8.54L118.74,275a1.24,1.24,0,0,1-.41.51.91.91,0,0,1-.53.18A.94.94,0,0,1,117.26,275.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.64,275.38a4.84,4.84,0,0,1-1.79-2.06,6.82,6.82,0,0,1-.6-2.91,7.06,7.06,0,0,1,.37-2.27,5.69,5.69,0,0,1,1-1.84,4.8,4.8,0,0,1,1.68-1.25,5.47,5.47,0,0,1,2.24-.45,5.72,5.72,0,0,1,2.84.73.57.57,0,0,1,.34.54.61.61,0,0,1-.17.44.55.55,0,0,1-.42.19.68.68,0,0,1-.25-.07l-.2-.1-.26-.12-.31-.12-.41-.12-.49-.07a6.08,6.08,0,0,0-.61,0,4,4,0,0,0-1.38.23,3.12,3.12,0,0,0-1,.65,3.82,3.82,0,0,0-.72,1,5.18,5.18,0,0,0-.42,1.24,7.12,7.12,0,0,0,0,2.81,5,5,0,0,0,.42,1.23,3.6,3.6,0,0,0,.72,1,3.1,3.1,0,0,0,1.06.64,3.93,3.93,0,0,0,1.41.24,3.76,3.76,0,0,0,1.22-.19,7.06,7.06,0,0,0,1.14-.53.56.56,0,0,1,.3-.08.54.54,0,0,1,.41.18.58.58,0,0,1,.18.42.72.72,0,0,1-.4.61,5.51,5.51,0,0,1-3.09.86A5.09,5.09,0,0,1,128.64,275.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.64,399h-5.4l-.93,2.39a.73.73,0,0,1-.73.52.84.84,0,0,1-.54-.2.62.62,0,0,1-.24-.49.83.83,0,0,1,.06-.29l3.73-9.26a1.93,1.93,0,0,1,.57-.88,1.54,1.54,0,0,1,1.55,0,1.93,1.93,0,0,1,.58.88L123,401a.68.68,0,0,1,.07.29.63.63,0,0,1-.25.49.85.85,0,0,1-.55.2.73.73,0,0,1-.72-.52Zm-2.7-6.93-2.26,5.8h4.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.89,401.29a4.8,4.8,0,0,1-1.79-2.05,6.82,6.82,0,0,1-.6-2.91,7,7,0,0,1,.37-2.27,5.74,5.74,0,0,1,1-1.85,4.58,4.58,0,0,1,1.68-1.24,5.28,5.28,0,0,1,2.24-.46,5.72,5.72,0,0,1,2.84.73.59.59,0,0,1,.34.54.64.64,0,0,1-.17.44.54.54,0,0,1-.42.19.73.73,0,0,1-.26-.06l-.19-.1-.26-.13-.31-.11-.41-.12a4.18,4.18,0,0,0-.49-.08,6.08,6.08,0,0,0-.61,0,3.77,3.77,0,0,0-1.38.24,2.87,2.87,0,0,0-1,.65,3.79,3.79,0,0,0-.71,1,5,5,0,0,0-.42,1.23,7.17,7.17,0,0,0-.14,1.41,7,7,0,0,0,.14,1.41,4.75,4.75,0,0,0,.42,1.22,3.41,3.41,0,0,0,.72,1,3.11,3.11,0,0,0,1.06.65,4.17,4.17,0,0,0,1.41.23,3.78,3.78,0,0,0,1.22-.18,8,8,0,0,0,1.14-.53.58.58,0,0,1,.3-.09.54.54,0,0,1,.41.18.57.57,0,0,1,.17.42.74.74,0,0,1-.39.62,5.51,5.51,0,0,1-3.09.85A5,5,0,0,1,126.89,401.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.68,369.29a4.78,4.78,0,0,1-1.78-2.05,6.82,6.82,0,0,1-.6-2.91,7,7,0,0,1,.36-2.27,5.77,5.77,0,0,1,1-1.85,4.54,4.54,0,0,1,1.67-1.24,5.36,5.36,0,0,1,2.25-.46,5.68,5.68,0,0,1,2.83.73.61.61,0,0,1,.17,1,.52.52,0,0,1-.41.19.65.65,0,0,1-.26-.06l-.19-.1-.27-.13-.31-.11-.41-.12a3.85,3.85,0,0,0-.49-.08,5.93,5.93,0,0,0-.61,0,3.85,3.85,0,0,0-1.38.24,2.83,2.83,0,0,0-1,.65,4.07,4.07,0,0,0-.72,1,5,5,0,0,0-.42,1.23,7.18,7.18,0,0,0-.13,1.41,7,7,0,0,0,.13,1.41,4.75,4.75,0,0,0,.42,1.22,3.83,3.83,0,0,0,.72,1,3.21,3.21,0,0,0,1.06.65,4.17,4.17,0,0,0,1.41.23,3.73,3.73,0,0,0,1.22-.18,7.14,7.14,0,0,0,1.14-.53.64.64,0,0,1,.3-.09.58.58,0,0,1,.42.18.61.61,0,0,1,.17.42.74.74,0,0,1-.39.62,5.55,5.55,0,0,1-3.09.85A5,5,0,0,1,120.68,369.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.71,301.21a3.69,3.69,0,0,1,0-4.38,2.38,2.38,0,0,1,2-.88,2.71,2.71,0,0,1,1.2.26,2.28,2.28,0,0,1,.85.71,3.55,3.55,0,0,1,.47,1,3.68,3.68,0,0,1,.16,1.11,3.31,3.31,0,0,1-.73,2.19,2.63,2.63,0,0,1-3.9,0Zm2.83-.34a1.76,1.76,0,0,0,.49-.79,3.92,3.92,0,0,0,.13-1.07A3.8,3.8,0,0,0,120,298a1.66,1.66,0,0,0-.49-.79,1.27,1.27,0,0,0-.88-.32,1.24,1.24,0,0,0-.87.32,1.74,1.74,0,0,0-.49.79,3.8,3.8,0,0,0-.13,1.06,3.92,3.92,0,0,0,.13,1.07,1.85,1.85,0,0,0,.49.79,1.24,1.24,0,0,0,.87.32A1.27,1.27,0,0,0,119.54,300.87Zm-.77,6.57a.43.43,0,0,1-.14-.32.6.6,0,0,1,.09-.27L124.85,296a.51.51,0,0,1,.45-.3.44.44,0,0,1,.32.13.48.48,0,0,1,.13.33.75.75,0,0,1-.1.33l-6.11,10.78a.5.5,0,0,1-.43.3A.5.5,0,0,1,118.77,307.44Zm5.49-1a3.41,3.41,0,0,1-.71-2.21,3.26,3.26,0,0,1,.73-2.17,2.37,2.37,0,0,1,1.94-.88,2.62,2.62,0,0,1,1.2.27,2.14,2.14,0,0,1,.84.7,3.49,3.49,0,0,1,.47,1,3.77,3.77,0,0,1,.16,1.11,3.65,3.65,0,0,1-.31,1.54,2.65,2.65,0,0,1-.93,1.11,2.66,2.66,0,0,1-3.39-.44Zm2.83-.35a1.76,1.76,0,0,0,.49-.78,4,4,0,0,0,.13-1.08,3.48,3.48,0,0,0-.08-.81,2.49,2.49,0,0,0-.24-.68,1.26,1.26,0,0,0-1.17-.68,1.27,1.27,0,0,0-.88.32,1.66,1.66,0,0,0-.48.79,4.12,4.12,0,0,0,0,2.13,1.66,1.66,0,0,0,.48.79,1.27,1.27,0,0,0,.88.32A1.24,1.24,0,0,0,127.09,306.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.92,306.81a.66.66,0,0,1-.24-.52.82.82,0,0,1,.08-.34l3.84-8.82h-5.17a.62.62,0,0,1-.47-.19.65.65,0,0,1,0-.88.58.58,0,0,1,.47-.19h6a1,1,0,0,1,.65.2.68.68,0,0,1,.23.54,1.75,1.75,0,0,1-.14.67l-4,9.3a.67.67,0,0,1-.67.44A.84.84,0,0,1,157.92,306.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,306.84a3.05,3.05,0,0,1-1.38-1.09,2.88,2.88,0,0,1-.52-1.73,3,3,0,0,1,.58-1.82,2.69,2.69,0,0,1,1.65-1,2.53,2.53,0,0,1-1.53-.92,2.66,2.66,0,0,1-.52-1.65,2.7,2.7,0,0,1,.51-1.65,2.92,2.92,0,0,1,1.32-1,5,5,0,0,1,1.86-.33,5.59,5.59,0,0,1,1.45.19,4,4,0,0,1,1.17.56,2.64,2.64,0,0,1,.8.95,2.92,2.92,0,0,1,.29,1.3,2.62,2.62,0,0,1-.53,1.66,2.56,2.56,0,0,1-1.51.91,3,3,0,0,1,1.66,1,2.85,2.85,0,0,1,.56,1.79,3,3,0,0,1-.52,1.73,3.13,3.13,0,0,1-1.39,1.09,5.75,5.75,0,0,1-3.95,0Zm3.63-1.33a1.74,1.74,0,0,0,.64-1.48,2,2,0,0,0-.65-1.58,2.43,2.43,0,0,0-1.64-.55,2.45,2.45,0,0,0-1.65.55,2,2,0,0,0-.66,1.58,1.9,1.9,0,0,0,.32,1.12,1.81,1.81,0,0,0,.83.65,3,3,0,0,0,1.16.2A2.63,2.63,0,0,0,197.6,305.51Zm0-5.5a1.71,1.71,0,0,0,.59-1.4,1.58,1.58,0,0,0-.63-1.38,2.63,2.63,0,0,0-1.57-.45,3.54,3.54,0,0,0-.82.1,2.45,2.45,0,0,0-.7.31,1.42,1.42,0,0,0-.5.58,1.86,1.86,0,0,0-.18.84,1.71,1.71,0,0,0,.59,1.4,2.94,2.94,0,0,0,3.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,306.61a.5.5,0,0,1-.3-.49.81.81,0,0,1,.17-.49.52.52,0,0,1,.41-.23.49.49,0,0,1,.19.05,4.62,4.62,0,0,0,2,.47,3.48,3.48,0,0,0,1-.12,2.45,2.45,0,0,0,.73-.33,2.06,2.06,0,0,0,.52-.54,3.32,3.32,0,0,0,.36-.7,4.59,4.59,0,0,0,.22-.87,8,8,0,0,0,.11-1c0-.32,0-.69,0-1.09a2.11,2.11,0,0,1-.94,1.13,3.28,3.28,0,0,1-1.78.49,3.47,3.47,0,0,1-2.58-1,3.51,3.51,0,0,1-1-2.57,3.63,3.63,0,0,1,1-2.67,3.69,3.69,0,0,1,2.75-1,4.66,4.66,0,0,1,1.64.28,3.32,3.32,0,0,1,1.18.75,3.85,3.85,0,0,1,.76,1.14,5.51,5.51,0,0,1,.42,1.38,9.47,9.47,0,0,1,.12,1.55c0,.46,0,.88,0,1.28s-.09.82-.17,1.27a7.26,7.26,0,0,1-.34,1.21,4.51,4.51,0,0,1-.56,1.06,3.6,3.6,0,0,1-.82.87,3.79,3.79,0,0,1-1.14.56,5.46,5.46,0,0,1-1.51.2A5.38,5.38,0,0,1,228.22,306.61Zm4.61-5.49a2.5,2.5,0,0,0,.64-1.81,2.55,2.55,0,0,0-.6-1.73,2.09,2.09,0,0,0-1.69-.7,2.2,2.2,0,0,0-1.73.67,2.54,2.54,0,0,0-.6,1.78,2.73,2.73,0,0,0,.55,1.77,1.9,1.9,0,0,0,1.62.69A2.36,2.36,0,0,0,232.83,301.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.12,337.83a.65.65,0,0,1-.23-.52v-1.73h-4.48a.73.73,0,0,1-.58-.25.8.8,0,0,1-.22-.57,1,1,0,0,1,.14-.49l4.29-6.73a1.44,1.44,0,0,1,1.28-.74,1.16,1.16,0,0,1,.78.27,1,1,0,0,1,.32.82v6.54h1.13a.55.55,0,0,1,.43.17.59.59,0,0,1,.15.4.59.59,0,0,1-.15.41.55.55,0,0,1-.43.17h-1.14v1.73a.65.65,0,0,1-.23.52.78.78,0,0,1-.52.19A.83.83,0,0,1,161.12,337.83Zm-.23-3.4v-6l-3.75,6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.27,337.87a5.19,5.19,0,0,1-1.51-.94.43.43,0,0,1-.15-.34.72.72,0,0,1,.21-.49.62.62,0,0,1,.45-.23.44.44,0,0,1,.28.1,3.66,3.66,0,0,0,2.49.94,2.31,2.31,0,0,0,1.76-.63,2.51,2.51,0,0,0,.6-1.78,2.41,2.41,0,0,0-.59-1.68,2,2,0,0,0-1.56-.64,3,3,0,0,0-1.25.29,2.71,2.71,0,0,0-1,.72.42.42,0,0,1-.31.1,1.39,1.39,0,0,1-.64-.17c-.22-.12-.32-.25-.32-.41v-5.12c0-.47.25-.71.76-.71h5.14a.52.52,0,0,1,.43.18.65.65,0,0,1,.16.42.64.64,0,0,1-.15.42.57.57,0,0,1-.44.17H194v3.79l.1-.1a2.1,2.1,0,0,1,.28-.22,4.11,4.11,0,0,1,.48-.27,3.52,3.52,0,0,1,.69-.22,4.43,4.43,0,0,1,.9-.09,3.25,3.25,0,0,1,2.51,1,3.6,3.6,0,0,1,.95,2.58,3.47,3.47,0,0,1-1.07,2.65,3.86,3.86,0,0,1-2.74,1A4.94,4.94,0,0,1,194.27,337.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.84,337.9a3.07,3.07,0,0,1-1.18-.75,3.8,3.8,0,0,1-.76-1.13,5.71,5.71,0,0,1-.42-1.39,9.38,9.38,0,0,1-.12-1.55c0-.45,0-.88,0-1.27a10.47,10.47,0,0,1,.18-1.27,6.54,6.54,0,0,1,.33-1.22,5.16,5.16,0,0,1,.56-1.06,3.48,3.48,0,0,1,2-1.42,5,5,0,0,1,1.5-.21,5.56,5.56,0,0,1,2.43.58.52.52,0,0,1,.29.5.83.83,0,0,1-.17.49.49.49,0,0,1-.41.22.38.38,0,0,1-.19-.05,4.77,4.77,0,0,0-2-.47,3.48,3.48,0,0,0-.95.12,2.67,2.67,0,0,0-.72.34,2,2,0,0,0-.53.54,3.09,3.09,0,0,0-.36.7,4.3,4.3,0,0,0-.22.86,8.4,8.4,0,0,0-.11,1c0,.32,0,.68,0,1.09a2,2,0,0,1,.94-1.13,3.17,3.17,0,0,1,1.78-.49,3.38,3.38,0,0,1,3.55,3.57,3.62,3.62,0,0,1-1,2.66,3.69,3.69,0,0,1-2.75,1A4.37,4.37,0,0,1,229.84,337.9Zm-.09-5.19a2.8,2.8,0,0,0,0,3.54,2.12,2.12,0,0,0,1.69.69,2.22,2.22,0,0,0,1.73-.66,2.57,2.57,0,0,0,.6-1.79,2.79,2.79,0,0,0-.54-1.77,2,2,0,0,0-1.63-.69A2.37,2.37,0,0,0,229.75,332.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.67,370.31a.69.69,0,0,1-.23-.55V361L157.75,362a.59.59,0,0,1-.31.09.56.56,0,0,1-.3-1l2.69-1.68a.81.81,0,0,1,.43-.11.73.73,0,0,1,.53.2.74.74,0,0,1,.21.57v9.69a.69.69,0,0,1-.23.55.87.87,0,0,1-.56.2A.85.85,0,0,1,159.67,370.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.07,364.09a6.57,6.57,0,0,1-1.43,1.74l-3.58,3.49h4.72a.62.62,0,0,1,.46.17.6.6,0,0,1,.16.42.57.57,0,0,1-.16.42.59.59,0,0,1-.46.18h-5.4a1.17,1.17,0,0,1-.74-.23.72.72,0,0,1-.28-.58,1.08,1.08,0,0,1,.37-.77l4.08-4.13a6.12,6.12,0,0,0,.93-1.2,2.24,2.24,0,0,0,.3-1.09,2,2,0,0,0-.6-1.5,2.05,2.05,0,0,0-1.47-.57,4.25,4.25,0,0,0-1,.1,3.76,3.76,0,0,0-.62.17,4.43,4.43,0,0,0-.55.29l-.44.26a.59.59,0,0,1-.23.05.56.56,0,0,1-.43-.2.61.61,0,0,1-.19-.45.54.54,0,0,1,.3-.48,7.47,7.47,0,0,1,1.49-.72,5.23,5.23,0,0,1,1.75-.25,3.45,3.45,0,0,1,2.45.92,3,3,0,0,1,1,2.24A3.6,3.6,0,0,1,199.07,364.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.43,370.09a.64.64,0,0,1-.41-.58.65.65,0,0,1,.18-.46.56.56,0,0,1,.42-.2.88.88,0,0,1,.2,0,5.09,5.09,0,0,0,2.16.52,2.71,2.71,0,0,0,1.69-.49,1.61,1.61,0,0,0,.65-1.37,2,2,0,0,0-.75-1.64,2.89,2.89,0,0,0-1.9-.61h-.57a.48.48,0,0,1-.41-.17.55.55,0,0,1-.15-.4.59.59,0,0,1,.15-.41.48.48,0,0,1,.41-.17h.51a2.87,2.87,0,0,0,1.76-.5,1.71,1.71,0,0,0,.66-1.45,1.6,1.6,0,0,0-.6-1.33,2.36,2.36,0,0,0-1.48-.47,5.05,5.05,0,0,0-2.3.54.48.48,0,0,1-.18,0,.53.53,0,0,1-.42-.23.76.76,0,0,1-.18-.49.49.49,0,0,1,.26-.45,4.67,4.67,0,0,1,1.2-.45,6.36,6.36,0,0,1,1.64-.23,5.07,5.07,0,0,1,1.84.32,3,3,0,0,1,1.31,1,2.86,2.86,0,0,1,.5,1.69,2.41,2.41,0,0,1-.52,1.57,3,3,0,0,1-1.38.92,2.65,2.65,0,0,1,1.58,1,3,3,0,0,1,.59,1.86,3.12,3.12,0,0,1-.32,1.42,2.61,2.61,0,0,1-.87,1,4,4,0,0,1-1.21.55,5.57,5.57,0,0,1-1.44.18A5.42,5.42,0,0,1,228.43,370.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.07,400.87a3.22,3.22,0,0,1-1.14-.85,4.44,4.44,0,0,1-.71-1.29,7.13,7.13,0,0,1-.39-1.56,13.57,13.57,0,0,1-.11-1.75q0-5.79,3.95-5.79c2.62,0,3.94,1.93,3.94,5.79a13.53,13.53,0,0,1-.11,1.74,7.13,7.13,0,0,1-.39,1.56,4.19,4.19,0,0,1-.71,1.29,3.15,3.15,0,0,1-1.13.85,3.72,3.72,0,0,1-1.6.32A3.81,3.81,0,0,1,158.07,400.87Zm2.38-1.11a1.92,1.92,0,0,0,.59-.4,2.67,2.67,0,0,0,.41-.62,4.16,4.16,0,0,0,.28-.74,6.14,6.14,0,0,0,.16-.85c0-.32.07-.61.08-.88s0-.55,0-.85,0-.63,0-.9,0-.57-.08-.89a5.8,5.8,0,0,0-.17-.85,4.16,4.16,0,0,0-.28-.74,2.05,2.05,0,0,0-.41-.6,1.74,1.74,0,0,0-.59-.39,2.08,2.08,0,0,0-1.55,0,1.83,1.83,0,0,0-.58.38,2.28,2.28,0,0,0-.42.6,4.16,4.16,0,0,0-.28.74c-.06.25-.11.54-.16.86s-.07.61-.08.89,0,.57,0,.9,0,.59,0,.86,0,.56.08.87a5.87,5.87,0,0,0,.16.85,4.25,4.25,0,0,0,.28.75,2.17,2.17,0,0,0,.41.61,1.81,1.81,0,0,0,.59.4,1.94,1.94,0,0,0,.78.15A2,2,0,0,0,160.45,399.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,397.25A1.77,1.77,0,0,1,194,396a1.72,1.72,0,0,1,.55-1.27,1.91,1.91,0,0,1,1.44-.55,2,2,0,0,1,1.43.54,1.73,1.73,0,0,1,.55,1.28,1.8,1.8,0,0,1-.54,1.3,2,2,0,0,1-1.44.54A2,2,0,0,1,194.5,397.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.1,265.53a1.74,1.74,0,0,1,0-2.5,2.12,2.12,0,0,1,2.79,0,1.69,1.69,0,0,1,.54,1.25,1.74,1.74,0,0,1-.53,1.26,2.11,2.11,0,0,1-2.8,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.1,276a1.76,1.76,0,0,1-.53-1.27,1.69,1.69,0,0,1,.53-1.23,1.88,1.88,0,0,1,1.4-.53,1.9,1.9,0,0,1,1.39.52,1.67,1.67,0,0,1,.54,1.24,1.76,1.76,0,0,1-.53,1.27,2.11,2.11,0,0,1-2.8,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,395a.9.9,0,0,1-.28-.65.86.86,0,0,1,.29-.68,1.06,1.06,0,0,1,.74-.26h11.13a1,1,0,0,1,.72.26.82.82,0,0,1,.31.68.83.83,0,0,1-.31.66,1.08,1.08,0,0,1-.72.26h-11.2A1,1,0,0,1,226,395Zm0,5.13a.84.84,0,0,1-.28-.64.89.89,0,0,1,.29-.68,1.11,1.11,0,0,1,.74-.26h11.17a1,1,0,0,1,.7.26.86.86,0,0,1,.29.68.82.82,0,0,1-.3.65,1.08,1.08,0,0,1-.72.26H226.64A1,1,0,0,1,226,400.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.62,302.48l-3.13,4.2a.78.78,0,0,1-.63.36.66.66,0,0,1-.48-.2.64.64,0,0,1-.21-.47.7.7,0,0,1,.15-.43l3.49-4.56-3.28-4.47a.5.5,0,0,1-.12-.34.72.72,0,0,1,.25-.53.8.8,0,0,1,.56-.23.72.72,0,0,1,.6.34l3,4.07,3-4.06a.8.8,0,0,1,.65-.36.65.65,0,0,1,.46.18.57.57,0,0,1,.19.43.67.67,0,0,1-.14.4l-3.37,4.53,3.35,4.58a.69.69,0,0,1,.14.4.64.64,0,0,1-.25.49.87.87,0,0,1-.56.21.68.68,0,0,1-.59-.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.36,389.69a1.13,1.13,0,0,1-.31-.82v-5.19h-5.4a1.19,1.19,0,0,1-.83-.31,1,1,0,0,1,0-1.54,1.19,1.19,0,0,1,.84-.29h5.4V376.3a1.12,1.12,0,0,1,.31-.81,1,1,0,0,1,.8-.34,1.06,1.06,0,0,1,.8.33,1.13,1.13,0,0,1,.31.82v5.24h5.41a1.26,1.26,0,0,1,.84.29,1,1,0,0,1,.35.77,1,1,0,0,1-.35.77,1.2,1.2,0,0,1-.84.31h-5.41v5.19a1.12,1.12,0,0,1-.31.8,1,1,0,0,1-.8.34A1.06,1.06,0,0,1,267.36,389.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,336.71a.81.81,0,0,1-.23-.59v-3.78H113.3a.88.88,0,0,1-.61-.22.74.74,0,0,1,0-1.12.92.92,0,0,1,.62-.22h3.92V327a.86.86,0,0,1,.23-.6.75.75,0,0,1,.58-.24.77.77,0,0,1,.58.24.85.85,0,0,1,.23.6v3.8h3.94a.92.92,0,0,1,.6.22.7.7,0,0,1,.26.56.75.75,0,0,1-.25.56.88.88,0,0,1-.61.22h-3.94v3.78a.83.83,0,0,1-.23.58.74.74,0,0,1-.58.25A.75.75,0,0,1,117.45,336.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.1,333.51a.5.5,0,0,1,0-.85,1.12,1.12,0,0,1,.68-.18h10.77a1.09,1.09,0,0,1,.67.18.55.55,0,0,1,.24.43.52.52,0,0,1-.24.42,1.09,1.09,0,0,1-.67.18H262.78A1.12,1.12,0,0,1,262.1,333.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.36,338.84a.59.59,0,0,1-.17-.42.61.61,0,0,1,.17-.43.58.58,0,0,1,.45-.18h7.28a.54.54,0,0,1,.45.19.61.61,0,0,1,.17.42.57.57,0,0,1-.17.42.57.57,0,0,1-.45.18h-7.28A.58.58,0,0,1,125.36,338.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.17,341a.52.52,0,0,1-.55.1c-.14-.08-.2-.26-.19-.52a2.26,2.26,0,0,1,.35-1l8-13.89a2,2,0,0,1,.66-.78.52.52,0,0,1,.55-.1c.14.08.2.26.18.52a2.26,2.26,0,0,1-.35,1l-8,13.89A2.31,2.31,0,0,1,121.17,341Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.1,270a.5.5,0,0,1,0-.85,1.12,1.12,0,0,1,.68-.18h10.77a1.09,1.09,0,0,1,.67.18.55.55,0,0,1,.24.43.52.52,0,0,1-.24.42,1.09,1.09,0,0,1-.67.18H262.78A1.12,1.12,0,0,1,262.1,270Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.93,275.5a1.24,1.24,0,0,1-.41-.51l-3.66-8.21v8.54a.49.49,0,0,1-.21.42.91.91,0,0,1-.52.15.9.9,0,0,1-.51-.15.5.5,0,0,1-.22-.42V266a1,1,0,0,1,.36-.76,1.32,1.32,0,0,1,1.58-.07,1.54,1.54,0,0,1,.56.7l3.56,7.91L158,265.9a1.47,1.47,0,0,1,.55-.7,1.32,1.32,0,0,1,1.58.07,1,1,0,0,1,.36.76v9.29a.47.47,0,0,1-.22.42.9.9,0,0,1-.51.15.85.85,0,0,1-.51-.15.47.47,0,0,1-.22-.42v-8.54L155.4,275a1.22,1.22,0,0,1-.4.51.94.94,0,0,1-.54.18A.91.91,0,0,1,153.93,275.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.58,275.77a.68.68,0,0,1-.24-.56v-9.68a.7.7,0,0,1,.24-.54.77.77,0,0,1,.56-.23h3.4a8.51,8.51,0,0,1,1.18.07,5.27,5.27,0,0,1,1.08.25,3,3,0,0,1,.91.49,2.21,2.21,0,0,1,.6.82,2.78,2.78,0,0,1,.23,1.19,2.39,2.39,0,0,1-.59,1.65,3,3,0,0,1-1.77.91v0a2.57,2.57,0,0,1,2.08,2.52l.28,2.46a.34.34,0,0,1,0,.11.64.64,0,0,1-.22.51.75.75,0,0,1-.52.2.91.91,0,0,1-.57-.19.67.67,0,0,1-.29-.52l-.24-2.19a7.54,7.54,0,0,0-.19-1.11,1.5,1.5,0,0,0-.36-.67,1.19,1.19,0,0,0-.61-.36,4.43,4.43,0,0,0-1-.09h-2.62v4.37a.68.68,0,0,1-.24.56.87.87,0,0,1-.56.2A.81.81,0,0,1,163.58,275.77Zm3.63-6.14c.31,0,.59,0,.83,0a4.28,4.28,0,0,0,.74-.16,1.82,1.82,0,0,0,.62-.32,1.54,1.54,0,0,0,.4-.55,2,2,0,0,0,.16-.83,2.08,2.08,0,0,0-.11-.69,1.08,1.08,0,0,0-.31-.48,2,2,0,0,0-.42-.3,1.89,1.89,0,0,0-.55-.16L168,266h-3.08v3.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.6,275.5a1.16,1.16,0,0,1-.41-.51l-3.66-8.21v8.54a.47.47,0,0,1-.22.42.85.85,0,0,1-.51.15.9.9,0,0,1-.51-.15.47.47,0,0,1-.22-.42V266a1,1,0,0,1,.36-.76,1.25,1.25,0,0,1,.83-.3,1.32,1.32,0,0,1,.75.23,1.54,1.54,0,0,1,.56.7l3.56,7.91,3.56-7.91a1.53,1.53,0,0,1,.55-.7A1.32,1.32,0,0,1,196,265a1.27,1.27,0,0,1,.84.3,1,1,0,0,1,.36.76v9.29a.5.5,0,0,1-.22.42.9.9,0,0,1-.51.15.91.91,0,0,1-.52-.15.49.49,0,0,1-.21-.42v-8.54L192.07,275a1.16,1.16,0,0,1-.41.51.87.87,0,0,1-1.06,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.1,272.22a.47.47,0,0,1-.17-.38.51.51,0,0,1,.17-.4.65.65,0,0,1,.46-.16h3.49a.61.61,0,0,1,.45.16.49.49,0,0,1,.18.4.45.45,0,0,1-.18.38.68.68,0,0,1-.45.15h-3.49A.69.69,0,0,1,199.1,272.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.26,275.5a1.24,1.24,0,0,1-.41-.51l-3.65-8.21v8.54a.47.47,0,0,1-.22.42.94.94,0,0,1-1,0,.47.47,0,0,1-.22-.42V266a1,1,0,0,1,.36-.76,1.23,1.23,0,0,1,.83-.3,1.27,1.27,0,0,1,.74.23,1.48,1.48,0,0,1,.56.7l3.57,7.91,3.56-7.91a1.53,1.53,0,0,1,.55-.7,1.32,1.32,0,0,1,1.58.07,1,1,0,0,1,.36.76v9.29a.47.47,0,0,1-.22.42.84.84,0,0,1-.5.15.89.89,0,0,1-.52-.15.5.5,0,0,1-.22-.42v-8.54L228.74,275a1.24,1.24,0,0,1-.41.51.91.91,0,0,1-.53.18A.94.94,0,0,1,227.26,275.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.1,275.77a.57.57,0,0,1-.16-.42v-2.72h-2.83a.65.65,0,0,1-.44-.16.52.52,0,0,1-.18-.4.51.51,0,0,1,.18-.41.65.65,0,0,1,.44-.15h2.83v-2.74a.6.6,0,0,1,.16-.43.54.54,0,0,1,.42-.17.53.53,0,0,1,.41.17.61.61,0,0,1,.17.43v2.74h2.83a.69.69,0,0,1,.44.15.51.51,0,0,1,.18.41.52.52,0,0,1-.18.4.63.63,0,0,1-.44.16H241.1v2.72a.61.61,0,0,1-.17.42.57.57,0,0,1-.41.17A.51.51,0,0,1,240.1,275.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "226.5 239 231 245 236 236 241 236",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorBro);
export default __webpack_public_path__ + "static/media/Calculator-bro.9ee1d554de022d00c16835e48af28744.svg";
export { ForwardRef as ReactComponent };